<template>
  <div class="modal fade" tabindex="-1" role="dialog" v-on:keyup.enter="link">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <div class="modal-header">
          <h4 class="modal-title">Add one or more testimonies to the following case : </h4>
        </div>
        <div class="modal-body col-lg-6">
            <multiselect
                v-model="selected" 
                :options="testimonies"
                :multiple="true"
                track-by="_id"
                :custom-label="customLabel">
            </multiselect>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          <button v-on:click="link" type="button" class="btn btn-danger" data-dismiss="modal">Confirm</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import api from '../../api'
  import moment from 'moment'

  export default {
    props: ['preselected'],
    name: 'LinkTestimonyModal',
    components: { Multiselect },
    data () {
      return {
        selected: null,
        testimonies: []
      }
    },
    methods: {
      link () {
        window.jQuery('#LinkTestimonyModal').modal('hide')
        this.$emit('link', this.selected)
        this.selected = []
      },
      removeLinkedTestimonies () {
        this.testimonies = this.testimonies.filter((c) => {
          return !this.preselected.some((p) => {
            return p._id === c._id
          })
        })
        console.log(this.testimonies)
      },
      customLabel (option) {
        let label = `${moment(option.creationDate).format('DD/MM/YYYY')}`
        if (option.actionDetail && option.actionDetail.actionLocation && option.actionDetail.actionLocation.zone) {
          label = label + ` - ${option.actionDetail.actionLocation.zone}`
          if (option.victimIdentity && option.victimIdentity.name) {
            label = label + ` - ${option.victimIdentity.name}`
          }
        } else if (option.victimIdentity && option.victimIdentity.name) {
          label = label + ` - ${option.victimIdentity.name}`
        }

        return label
      },
      getTestimonies () {
        api.authenticatedRequest('get', `/testimonies?size=100`)
        .then(response => {
          this.testimonies = response.data.data
          return this.testimonies
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) { // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getTestimonies()
      })
    }
  }

</script>

<style>
.modal-dialog, .modal-content {
    width: 100% !important;
    height: 100% !important;
}
.modal-dialog {
    margin: 0 !important;
}
.modal-content {
    background: rgba(255, 255, 255, .92);
    align-content: center;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}
.modal.fade.in {
    display: flex !important;
}
.modal-header, .modal-footer {
  border: none;
}

.modal.in .modal-dialog, .modal.fade .modal-dialog {
    transform: none;
    opacity: 1;
    transition: opacity .3s ease;
}

.modal .close {
    width: 2rem;
    height: 3rem;
    cursor: pointer;
    fill: #555;
    position: absolute;
    right: 4rem;
    top: 3rem;
    transition: fill .2s;
    display: block;
    font-size: 30px;
    outline: none;
}

.modal-footer button:active:focus {
    outline: none;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// LinkTestimonyModal.vue?7393691e